import script from "./AccordionSelectTabsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionSelectTabsSection.vue?vue&type=script&setup=true&lang=js"

import "./AccordionSelectTabsSection.vue?vue&type=style&index=0&id=6c4ad2cd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c4ad2cd"]])

export default __exports__